<template>
    <network-settings></network-settings>
</template>

<script>
// @ is an alias to /src
import NetworkSettings from "@/components/NetworkSettings.vue";

export default {
  components: {
    NetworkSettings
  },
  created() {
    this.$store.dispatch("info/fetchInfo").then(() => {
      console.log("Loading Info Complete");
    });
  }
};
</script>
